<template>
	<div class="chat-container w-100 position-relative pt-5">
    <top-navbar :run_function="true" @on-back="backPage" />
		<template v-if="toggle_data == 'email'">
			<div class="container mt-8">
	    	<div class="px-2">
	    		<p class="mb-1 heading-5 text-center">{{$t('profile.forgot-password')}}</p>
	    		<p class="mb-0 body-1 font-regular text-center">{{$t('profile.forgot-pass.sub-heading')}}</p>
	    		<p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('profile.login.email')}}</p>
	    		<input type="email" v-model="form.email" class="form-control pl-3 mt-2 body-1-2 mb-0" placeholder="user@guestaps.com">
	    	</div>
    	</div>
	    <wrapper-mobile-view fixed_position="bottom">
				<div class="px-4 pb-4 bg-white">
        	<div v-if="error.email.show" class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
            <p class="mb-0 body-3-1 text-capitalize">{{error.email.message}}</p>
          </div>
        	<div @click="sendEmailSubmit" class="rounded-6 px-4 py-3 text-center" :class="{'bg-green cursor-pointer': is_email_form_valid, 'bg-green-disabled cursor-disable' : !is_email_form_valid || form.loading.email}">
        		<pulse-loader :loading="form.loading.email" v-if="form.loading.email"></pulse-loader>
            <p class="text-white body-15 mb-0 ls-1-25" v-else>{{$t('profile.forgot-pass.send-otp')}}</p>
          </div>
		    </div>
		  </wrapper-mobile-view>    			
		</template>
		<template v-if="toggle_data == 'code'">
	    <div class="container mt-8">
	    	<div class="px-2">
	    		<p class="mb-1 heading-5 text-center">{{$t('profile.forgot-pass.enter-the-code')}}</p>
	    		<p class="mb-0 body-2 font-regular text-color-dark text-center mb-3">{{$t('profile.forgot-pass.enter-code')}} {{getForgotPassword()}}</p>
	    		<!-- <input class="form-control mx-auto mt-4 body-1 text-color-dark" id="otp-code" type="text" maxlength="4" /> -->
	    		<div class="w-100 text-center">
		    		<input ref="input_1" class="form-control mt-4 body-1 text-color-dark forgot-input border-semi-grey rounded-6 text-center px-0" type="text" v-model="form.code.input_1" maxlength="1" @focus="focusCode('input_1')" @input="inputCode('input_1',1)" />
		    		<input ref="input_2" class="form-control mt-4 body-1 text-color-dark forgot-input border-semi-grey rounded-6 text-center px-0" type="text" v-model="form.code.input_2" maxlength="1" @focus="focusCode('input_2')" @input="inputCode('input_2',2)" />
		    		<input ref="input_3" class="form-control mt-4 body-1 text-color-dark forgot-input border-semi-grey rounded-6 text-center px-0" type="text" v-model="form.code.input_3" maxlength="1" @focus="focusCode('input_3')" @input="inputCode('input_3',3)" />
		    		<input ref="input_4" class="form-control mt-4 body-1 text-color-dark forgot-input border-semi-grey rounded-6 text-center px-0" type="text" v-model="form.code.input_4" maxlength="1" @focus="focusCode('input_4')" @input="inputCode('input_4',4)" />
		    		<input ref="input_5" class="form-control mt-4 body-1 text-color-dark forgot-input border-semi-grey rounded-6 text-center px-0" type="text" v-model="form.code.input_5" maxlength="1" @focus="focusCode('input_5')" @input="inputCode('input_5',5)" />
		    		<input ref="input_6" class="form-control mt-4 body-1 text-color-dark forgot-input border-semi-grey rounded-6 text-center px-0" type="text" v-model="form.code.input_6" maxlength="1" @focus="focusCode('input_6')" @input="inputCode('input_6',6)" />
	    		</div>
	    		<p class="mb-0 mt-5 body-2 font-regular text-color-dark text-center">{{$t('profile.forgot-pass.not-sent')}}</p>
	    	</div>
	  	</div>
	  	
			<wrapper-mobile-view fixed_position="bottom">
				<div class="px-4 pb-4 bg-white">
		    	<div @click="sendCodeSubmit" class="rounded-6 px-4 py-3 text-center" :class="{'bg-green cursor-pointer': is_code_form_valid, 'bg-green-disabled cursor-disable' : !is_code_form_valid}">
		        <p class="text-white body-15 mb-0 ls-1-25">{{$t('profile.forgot-pass.continue')}}</p>
		      </div>
		    </div>
      </wrapper-mobile-view>
						       
		</template>
		<template v-if="toggle_data == 'password'">
			<div class="container mt-8">
        <div class="px-2">
          <p class="mb-1 heading-5">{{$t('profile.forgot-pass.create-new-password')}}</p>
          <p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('general.new-password')}}</p>
          <input type="password" v-model="form.password.new" class="form-control pl-3 mt-2 body-1-2 mb-0">
          <p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('general.confirm-new-password')}}</p>
          <input type="password" v-model="form.password.confirm" class="form-control pl-3 mt-2 body-1-2 mb-0">
        </div>
      </div>
      <div class="fixed-bottom d-block nav-bottom" style="bottom: 11.5%;">
	      <div class="custom-container-fluid px-0">
	        <div class="row justify-content-center no-gutters">
	          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	            <div class="bg-white">
	              <div class="w-100">
						      <div class="container mt-5 mb-1">
						        <div class="px-2">
						        	<div v-if="error.password.show" class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
						            <p class="mb-0 body-3-1">{{error.password.message}}</p>
						          </div>
						        	<div @click="resetPasswordSubmit" class="rounded-6 px-4 py-3 text-center" :class="{'bg-green cursor-pointer': is_password_form_valid, 'bg-green-disabled cursor-disable' : !is_password_form_valid}">
						        		<pulse-loader :loading="form.loading.password" v-if="form.loading.password"></pulse-loader>
						            <p class="text-white body-15 mb-0 ls-1-25" v-else>{{$t('profile.forgot-pass.create-new-password')}}</p>
						          </div>
						        </div>
						    	</div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
		</template>
	</div>
</template>
<script>
	import {mapGetters,mapActions} from 'vuex';
	import {post} from '@/services/index.js';
	const { email,required,sameAs } = require("vuelidate/lib/validators");
	export default{
		data(){
			return{
				form:{
					email: '',
					code:{
						input_1:'',
						input_2:'',
						input_3:'',
						input_4:'',
						input_5:'',
						input_6:'',
					},
					password:{
						new: '',
						confirm: ''
					},
					loading:{
						email: false,
						password: false
					}
				},
				toggle_data: 'email',
				error:{
					email: {
						show: false,
						message: ''
					},
					password: {
						show: false,
						message: ''
					}
				}
			}
		},
		created(){
			if (this.getForgotPassword() != '') {
				this.form.email = this.getForgotPassword()
				this.toggle_data = 'code'
			}
		},
		mounted(){
      this.$validateUserMenu();
			if (!this.isNotLogin()) {
    		this.$router.push({
    			path: '/'+this.getMerchant().code+'/account'
    		})
    	}
		},
		validations: {
      form: {
        email:{
         	required,
         	email
        },
        code:{
        	input_1:{
        		required
        	},
        	input_2:{
        		required
        	},
        	input_3:{
        		required
        	},
        	input_4:{
        		required
        	},
        	input_5:{
        		required
        	},
        	input_6:{
        		required
        	}
        },
        password:{
        	new:{
	        	required,
	        	sameAsPassword: sameAs('confirm')
	        },
	        confirm:{
	        	required,
	        	sameAsPassword: sameAs('new')
	        }
        }
      },
    },
    computed:{
    	is_email_form_valid(){
    		return (this.$v.form.email.$invalid == false) ? true : false
    	},
    	is_code_form_valid(){
    		return (this.$v.form.code.input_1.$invalid == false &&
    			this.$v.form.code.input_2.$invalid == false &&
    			this.$v.form.code.input_3.$invalid == false &&
    			this.$v.form.code.input_4.$invalid == false &&
    			this.$v.form.code.input_5.$invalid == false &&
    			this.$v.form.code.input_6.$invalid == false) ? true : false
    	},
    	is_password_form_valid(){
    		return (this.$v.form.password.new.$invalid == false && this.$v.form.password.confirm.$invalid == false) ? true : false
    	}
    },
		methods:{
			...mapGetters(['getForgotPassword','getMerchant','isNotLogin','getMetaTitleTemplate']),
			...mapActions(['setForgotPassword']),
			inputCode(input,index){
				let next_input = 'input_'+(index+1)
				if (index === 6) {
					if (this.form.code[input].length == 1) {
						this.$refs[input].blur();
					}
				}else{
					if (this.form.code[input].length >= 1) {
						this.$refs[next_input].focus();
					}
				}
			},
			focusCode(input){
				if (this.form.code[input].length >= 1) {
					this.$refs[input].select()
				}
			},
			backPage(){
				if (this.toggle_data == 'email') {
					this.$router.push({
						path: '/'+this.getMerchant().code+'/login'
					})
				}else if(this.toggle_data == 'code'){
					this.toggle_data = 'email'
				}else if(this.toggle_data == 'password'){
					this.toggle_data = 'code'
				}
			},
			sendEmailSubmit(){
				if (this.is_email_form_valid && !this.form.loading.email) {
					this.form.loading.email = true
					post("BASE","reset-password",{
						username: this.form.email
					}).then(response=>{
						let res = response.data
						if (res.success) {
							this.setForgotPassword(this.form.email)
							this.toggle_data = 'code'
						}else{
							this.error.email.show = true
							this.error.email.message = res.message
						}
						this.form.loading.email = false
					})
				}
			},
			sendCodeSubmit(){
				if (this.is_code_form_valid) {
					this.toggle_data = 'password'
				}
			},
			resetPasswordSubmit(){
				if (this.is_password_form_valid && !this.form.loading.password) {
					this.form.loading.password = true
					let params = {
						username: this.form.email,
						otp: this.form.code.input_1+this.form.code.input_2+this.form.code.input_3+this.form.code.input_4+this.form.code.input_5+this.form.code.input_6,
						new_password: this.form.password.new,
						re_new_password:  this.form.password.confirm
					}
					post("BASE","reset-password-val",params).then(response=>{
						let res = response.data
						if (res.success) {
							this.setForgotPassword("")
							this.$router.push({
								path: '/'+this.getMerchant().code+'/login'
							})
						}else{
							this.error.password.show = true
							this.error.password.message = res.message
						}
						this.form.loading.password = false
					})
				}
			}
		}
	}
</script>
<style scoped>
	.px0{
		padding-left: 0px!important;
		padding-right: 0px!important;
	}
	.color-red{
		color: red;
	}
	.forgot-input{
		display: inline-block;
		vertical-align: middle;
		width: 45px;
		margin: 0px 5px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/general/ForgotPassword.vue